import { Address } from '../../../features/address'
import { Data2, newId } from '../../../features/data-types'
import { useSystemStateHooks } from '../../system'
import { Branch } from '../state/types'

export const useBranchBuilders = () => {
    const { companyId: stateCompanyId } = useSystemStateHooks()

    const buildBranch = (data: Data2) => {
        const { companyId = stateCompanyId, id = newId(), code, name, address } = data
        const branch: Branch = {
            companyId: companyId! as string,
            id: id! as string,
            code: code! as string,
            name: name! as string,
            address: address! as Address
        }

        return branch
    }

    return {
        buildBranch
    }
}
